import { mapActions } from 'vuex';
import amountInfo from '@/components/wallet/amount-info/amount-info.vue';
import { withMeta } from '@/helpers/dataLayer';
import { formMixin } from '@/components/forms/mixin';
import loaderMixin from '@/mixins/loader';

const RECEIVED_MESSAGE = 'Your withdrawal request has been received.';

export default {
  mixins: [
    formMixin,
    loaderMixin,
  ],
  components: {
    amountInfo,
  },
  props: {
    amendAvailable: {
      type: Boolean,
      required: false,
      default: false,
    },
    kind: {
      type: String,
      required: false,
    },
    amount: {
      type: Number,
      required: false,
    },
    bankWithdrawAmounts: {
      type: Object,
    },
    fee: {
      type: Number,
      required: false,
      default: 5.0,
    },
    beneficiaryInfo: {
      type: Object,
      required: false,
    },
    accountDetails: {
      type: Object,
      required: false,
    },
    addressLine1: {
      type: String,
      required: false,
    },
    addressLine2: {
      type: String,
      required: false,
    },
    addressLine3: {
      type: String,
      required: false,
    },
    country: {
      required: false,
    },
    recipient: {
      required: false,
    },
    feePercent: {},
  },
  data() {
    return {
      hasFailed: false,
    };
  },
  computed: {
    isAch() {
      return this.kind === 'ach' || this.isLinkedBankAch;
    },
    isLinkedBankAch() {
      return this.kind === 'linked-bank-ach';
    },
    isCheck() {
      return this.kind === 'check';
    },
    isCoinbase() {
      return this.kind === 'coinbase-withdraw';
    },
    isBankTransfer() {
      return this.kind === 'bank-transfer';
    },
    netTotal() {
      return this.amount - this.fee;
    },
    backText() {
      return this.hasFailed ? 'Back' : 'Cancel';
    },
  },
  methods: {
    ...mapActions('wallet', [
      'postWithdrawCheck', 'postWithdrawAch',
      'postWithdrawCoinbase', 'postWithdrawWireSubmit',
    ]),
    ...mapActions('notifications', ['setSuccessSideNotification']),
    inspectWithrawConfirmResponse(data) {
      if (data.isTLEvent) {
        this.$gtm.trackEvent(withMeta({
          event: 'FullWithdraw',
        }));
      }
    },
    onEdit() {
      this.$emit('edit');
    },
    onSubmit() {
      this.formReset();
      this.loaderAdd(document.body);
      if (this.isCheck) {
        const payload = {
          amount: this.amount,
        };
        this.postWithdrawCheck(payload)
          .then((data) => {
            this.loaderRemove(document.body);
            this.inspectWithrawConfirmResponse(data);
            this.setSuccessSideNotification(RECEIVED_MESSAGE);
            this.$gtm.trackEvent(withMeta({ event: 'Withdraw' }));
            this.$emit('success');
          })
          .catch((error) => {
            this.hasFailed = true;
            this.loaderRemove(document.body);
            this.formHandleErrors(error);
            this.$gtm.trackEvent(withMeta({ event: 'FailWithdraw' }));
          });
      } else if (this.isAch) {
        const payload = {
          amount: this.amount,
        };
        if (this.isLinkedBankAch) {
          payload.linkedBankAccountId = this.accountDetails.linkedBankAccountId;
        } else {
          payload.savedAchAccountId = this.accountDetails.accountId;
          payload.achRoutingNumber = this.accountDetails.routingNumber;
          payload.achAccountNumber = this.accountDetails.accountNumber;
          payload.achAccountType = this.accountDetails.accountType;
        }
        this.postWithdrawAch(payload)
          .then((data) => {
            this.loaderRemove(document.body);
            this.inspectWithrawConfirmResponse(data);
            this.setSuccessSideNotification(RECEIVED_MESSAGE);
            this.$gtm.trackEvent(withMeta({ event: 'Withdraw' }));
            this.$emit('success');
          })
          .catch((error) => {
            this.hasFailed = true;
            this.loaderRemove(document.body);
            this.formHandleErrors(error);
            this.$gtm.trackEvent(withMeta({ event: 'FailWithdraw' }));
          });
      } else if (this.isCoinbase) {
        const payload = {
          amount: this.amount,
        };
        this.postWithdrawCoinbase(payload)
          .then((data) => {
            this.loaderRemove(document.body);
            this.inspectWithrawConfirmResponse(data);
            this.setSuccessSideNotification(RECEIVED_MESSAGE);
            this.$gtm.trackEvent(withMeta({ event: 'Withdraw' }));
            this.$emit('success');
          })
          .catch((error) => {
            this.hasFailed = true;
            this.loaderRemove(document.body);
            this.formHandleErrors(error);
            this.$gtm.trackEvent(withMeta({ event: 'FailWithdraw' }));
          });
      } else if (this.isBankTransfer) {
        const payload = {
          amount: this.amount,
          accountWireBeneficiaryId: this.beneficiaryInfo.accountWireBeneficiaryId,
        };
        this.postWithdrawWireSubmit(payload)
          .then((data) => {
            this.loaderRemove(document.body);
            this.inspectWithrawConfirmResponse(data);
            this.setSuccessSideNotification(RECEIVED_MESSAGE);
            this.$gtm.trackEvent(withMeta({ event: 'Withdraw' }));
            this.$emit('success');
          })
          .catch((error) => {
            this.hasFailed = true;
            this.loaderRemove(document.body);
            this.formHandleErrors(error);
            this.$gtm.trackEvent(withMeta({ event: 'FailWithdraw' }));
          });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/withdraw-confirm/withdraw-confirm.js